import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.322.08c-3.2.586-5.857 2.592-7.276 5.505-3.63 7.414 2.727 15.775 10.81 14.228 6.817-1.31 10.253-8.918 6.76-14.925-.68-1.156-2.364-2.87-3.491-3.54a9.785 9.785 0 0 0-4.66-1.337c-.821-.028-1.781 0-2.143.07Zm4.424 1.032c3.937 1.254 6.497 4.738 6.497 8.863 0 4.167-2.462 7.511-6.58 8.932-.752.265-1.21.321-2.644.321-1.586 0-1.85-.042-2.935-.418-3.005-1.06-5.342-3.581-6.052-6.55-.32-1.282-.306-3.484 0-4.654.696-2.565 2.504-4.78 4.828-5.895.723-.349 1.655-.697 2.073-.78.417-.084.89-.182 1.043-.21.654-.153 2.727.07 3.77.39Z"
    />
    <path
      fill="currentColor"
      d="M9.241 3.411c-3.144.794-3.825 4.947-1.112 6.633.932.572 2.406.67 3.338.223 1.183-.585 2.17-2.076 2.17-3.288 0-.558-.417-1.687-.806-2.244-.724-.99-2.42-1.617-3.59-1.324ZM8.445 11.522c-2.017.209-3.575 1.268-4.48 3.052l-.375.738.835.78c2.504 2.398 5.926 2.858 9.293 1.255 1.252-.585 2.56-1.672 2.56-2.104 0-.432-.752-1.645-1.42-2.3-.834-.822-1.878-1.254-3.38-1.435-1.377-.153-1.475-.153-3.033.014Z"
    />
  </svg>
)
export default SvgComponent
